/**=========================================================
 * Module: constants.js
 * Define constants to inject across the application
 =========================================================*/
App.constant("Api", {
    "url" :ENV_URL,
    "url2": ENV2_URL,
    "ws": WS_URL,
	"document_tab_iframe_url": DOCUMENT_TAB_IFRAME_URL,
	"admin_document_tab_iframe_url": ADMIN_DOCUMENT_TAB_IFRAME_URL,
	"task_tab_iframe_url": TASK_TAB_IFRAME_URL,
	"admin_task_tab_iframe_url": ADMIN_TASK_TAB_IFRAME_URL
});

const profileCheckList = [
	{
		id: ['personalDetails'],
		text: 'Profile Details',
		minStep:0,
		checked: true
	},
	{
		id: ['workPreferences'],
		text: 'Work Preferences',
		minStep:0,
		checked: false
	},
	{
		id: ['consents'],
		text: 'Consents',
		minStep:0,
		checked: false
	},
	{
		id: ['licenses'],
		text: 'Licenses',
		minStep:1,
		checked: false
	},
	{
		id: ['ssn'],
		text: 'SSN',
		minStep:1,
		checked: false
	},
	{
		id: ['certifications', 'additionalCertifications', 'specialties'],
		text: 'Specialty & Certifications',
		minStep:1,
		checked: false
	},
	{
		id: ['resumeFileUrl'],
		text: 'Resume',
		minStep:2,
		checked: false
	},
	{
		id: ['yearsOfExperience'],
		text: 'Years of Experience',
		minStep:2,
		checked: false
	},
	{
		id: ['references'],
		text: 'References',
		minStep:2,
		checked: false
	}
];

App.constant("UserConstants", {
    "profileCheckList" : profileCheckList
});

App.constant("BITLY_TOKEN", {
    "token" :'e70a5c9d0ef6ac25e9b700e03927122cda51676a'

});

App.constant('APP_REQUIRES', {
    // jQuery based and standalone scripts
    scripts: {
        'dashboard':        ['js/scripts/controllers/MainCtrl.js',
                            'js/scripts/directives/header/header.js',
                            'js/scripts/directives/header/header-notification/header-notification.js',
                            'js/scripts/directives/sidebar/sidebar.js',
                            'js/scripts/directives/sidebar/sidebar-search/sidebar-search.js',
                            'js/scripts/services/auth.js'],
        'profile':              ['js/scripts/controllers/ProfileCtrl.js',
                                'js/scripts/services/skill-checklist.js'],
        'splash':              ['js/scripts/controllers/ProfileNewCtrl.js',
                                'js/scripts/directives/header-new/header-new.js',
                                'js/scripts/directives/header-new/header-notification-new/header-notification-new.js',
                                'js/scripts/directives/credential-alerts/credential-alerts.js',
                                'js/scripts/directives/job-alerts/job-alerts.js'],
        'success':              ['js/scripts/controllers/AppSuccessCtrl.js',
                                'js/scripts/directives/header-new/header-new.js',
                                'js/scripts/directives/header-new/header-notification-new/header-notification-new.js'],
        'jobs':              ['js/scripts/controllers/JobsCtrl.js'],
        'contactUs':         ['js/scripts/controllers/ContactUsCtrl.js'],
        'notification':         ['js/scripts/controllers/notificationCtrl.js'],
        'income':         ['js/scripts/controllers/myIncomeCtrl.js'],
        'setting':         ['js/scripts/controllers/settingCtrl.js'],
        'page404':        ['js/scripts/controllers/Page404Ctrl.js',
                            'js/scripts/directives/header/header.js'],
        'nurseView':        ['js/scripts/controllers/phone-nurse.controller.js'],
        'nurse-view': ['js/scripts/controllers/NurseGuestViewController.js']

    }


  });


